<template>
	<div>
		<el-container>
			<el-header>
				<Header></Header>
			</el-header>
			<div style="width:98%;margin:0 auto;padding:0;padding: 0">
				<Nav></Nav>
			</div>
			<!--select-->
			<div class="select-block">
				<el-form :inline="true" :model="formInline" class="demo-form-inline">
					<el-form-item>
						<el-select placeholder="请选择资金年度" v-model="choseapplySubsidyTime" @change="changeChoseapplySubsidyTime" style="width: 160px" clearable>
							<el-option v-for="(item,index) in applySubsidyTime" :label="item.applySubsidyTime" :value="item.applySubsidyTime" :key="index">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select placeholder="请选择品目（资金年度必选）" v-model="pinmu" style="width: 220px" clearable>
							<el-option v-for="(item,index) in listThreeCategory" :label="item.dictName" :value="item.dictKey" :key="index">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model.trim="factoryImei" placeholder="请输入出厂编号" style="width: 160px" :clearable="true"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model.trim="imei" placeholder="请输入监控编号" style="width: 160px" :clearable="true"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model.trim="companyName" placeholder="请输入生产企业" style="width: 160px" :clearable="true"></el-input>
					</el-form-item>
					<provCity :provCityId="provCityId" v-if="this.$store.state.Code === '11'"></provCity>
					<el-form-item>
						<el-button type="primary" @click="onSubmit">查询</el-button>
						<!-- <a type="primary" @click="show = !show" style="margin-left: 16px">
              <a v-if="show" style="cursor: pointer">收起</a>
              <a v-if="!show" style="cursor: pointer">展开</a>
              <i :class="show ? 'el-icon-top' : 'el-icon-bottom'"/>
            </a> -->
					</el-form-item>
					<!--<i class="el-icon-info" style="float: right;margin-right:60px;font-size: 20px;margin-top:10px"  @click="open3"></i>-->
					<!-- <el-popover
            placement="right"
            width="200"
            trigger="click"
            content="列表中展示补贴办理已通过的机具（含已公示、待申请结算、待结算、已结算）">
            <i class="el-icon-info" style="float: right;margin-right:60px;font-size: 20px;margin-top:10px"  slot="reference"></i>
          </el-popover> -->
					<!-- <div style="margin-top: 20px; ">
            <el-collapse-transition>
              <div>
                <el-form-item>
                  <provCity :provCityId="provCityId"></provCity>
                </el-form-item>
              </div>
            </el-collapse-transition>
          </div> -->
				</el-form>
			</div>
			<!--table-->
			<el-main style="padding:0;margin-top: 10px;">
				<el-table :data="tableData">
					<el-table-column prop="id" label="序号" width="100" type="index">
						<template slot-scope="scope">
							<span>{{ (currentPage-1)*checkcurrentPage+parseInt(scope.$index)+1 }}</span>
						</template>
					</el-table-column>
					<!-- <el-table-column
            prop="qr_code"
            label="二维码"
            width="80"
          >
            <template slot-scope="scope">
              <el-popover
                placement="right"
                title=""
                trigger="hover">
                <img :src="scope.row.qr_code" class="code-img"/>
                <img slot="reference" :src="scope.row.qr_code" :alt="scope.row.qr_code" style="max-height: 20px;max-width: 20px">
              </el-popover>
            </template>
          </el-table-column> -->
					<el-table-column prop="name" label="机主姓名" :show-overflow-tooltip="true" popper-class="tips">
					</el-table-column>
					<el-table-column prop="nj_name" label="农机名称" :show-overflow-tooltip="true" popper-class="tips">
					</el-table-column>
					<el-table-column prop="factoryName" label="生产企业" :show-overflow-tooltip="true" popper-class="tips">
					</el-table-column>
					<el-table-column prop="factory_code" label="出厂编号" :show-overflow-tooltip="true" popper-class="tips">
					</el-table-column>
					<el-table-column prop="rectify_area" label="运行面积（亩）" :show-overflow-tooltip="true" popper-class="tips">
						<template slot-scope="scope">
							<div v-if="scope.row.rectify_area !==''">{{scope.row.rectify_area}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="applyTime" label="申请时间" :show-overflow-tooltip="true" popper-class="tips">
					</el-table-column>
					<el-table-column width="100" prop="applyYear" label="资金年度">
					</el-table-column>
					<el-table-column prop="imei" label="监控编号" :show-overflow-tooltip="true" popper-class="tips">
					</el-table-column>
					<el-table-column width="80" prop="address" label="操作">
						<template slot-scope="scope">
							<el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div v-if="nodata" class="zanwu">暂无数据</div>
			</el-main>
			<div class="block">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-size="checkcurrentPage" layout="total, prev, pager, next, jumper" :total="total" v-if="tableData&&tableData[0]">
				</el-pagination>
			</div>
			<div v-if="isloading" class="">
				<div class="el-loading-spinner"><i class="el-icon-loading"></i>
					<p class="el-loading-text">加载中</p>
				</div>
			</div>
		</el-container>
	</div>
</template>

<script>
	import Api from '../../Serves/net-api.js'
	import Http from '../../Serves/net-http.js'
	import provCity from "../Index/common/provCity"
	import Nav from "../../components/Index/nav";
	import { mapState } from "vuex"
	export default {
		name: "Discount",
		components: {
			provCity,
			Nav
		},
		data() {
			return {
				nodata: false,
				isloading: true,
				loading: false, //表格加载状态
				total: 1,
				currentPage: 1,
				pageSize: '',
				token: '',
				provCityId: {
					cityCode: '',
					provCode: '',
					countyCode: ''
				}, //省市区组件id
				listThreeCategory: [],
				pinmu: '',
				formInline: {
					user: '',
					region: ''
				},
				checkcurrentPage: 12,
				factoryImei: '',
				factoryCode: '',
				companyName: '',
				imei: '',
				status: false,
				value: '',
				options: [{}],
				tableData: [],
				choseYear: null,
				subsidyYear: [{
					label: 2020,
					value: 2020
				}, {
					label: 2019,
					value: 2019
				}, {
					label: 2018,
					value: 2018
				}],
				choseqrcode: null,
				choseimei: null,
				choseapplySubsidyTime: '',
				buyYear: [{
					label: 2020,
					value: 2020
				}, {
					label: 2019,
					value: 2019
				}, {
					label: 2018,
					value: 2018
				}],
				qr_code: [{
					label: '是',
					value: 'yes'
				}, {
					label: '否',
					value: 'no'
				}],
				hasImei: [{
					label: '是',
					value: 'yes'
				}, {
					label: '否',
					value: 'no'
				}],
				// applySubsidyTime: [{label:2020,value:2020},{label:2019,value:2019},{label:2018,value:2018}],
				applySubsidyTime: [],
				show: false,
				visible: false
			}
		},
		computed: {
			...mapState({
				result: state => state.result
			})
		},
		created(){
      this.getlistThreeCategory()
		},
		mounted(){
      if (this.$store.state.discountData.length !== 0) {
        var data = this.$store.state.discountData
        this.pinmu = data.pinmu
        this.factoryImei = data.factoryImei
        this.companyName = data.companyName
        this.imei = data.imei
        this.currentPage = data.currentPage
        this.checkcurrentPage = 12
        this.choseYear = data.choseYear
        this.choseqrcode = data.choseqrcode
        this.choseimei = data.pinmu
        this.choseapplySubsidyTime = Number(data.choseapplySubsidyTime)
        this.getYear(this.choseapplySubsidyTime)
      } else {
        this.choseapplySubsidyTime = new Date().getFullYear()
        this.getYear(this.choseapplySubsidyTime)
      }
    },
		methods: {
			getYear (value) {
        var url=Http.test+'/subsidyMachine/getApplySubsidyTime'
        Api.doPost(url,null,false,(res)=>{
          this.applySubsidyTime = res.result
          if (this.applySubsidyTime.length === 0) {
            this.choseapplySubsidyTime = ''
            // this.getlistThreeCategory()
          } else {
            this.choseapplySubsidyTime = value
            // this.getlistThreeCategory(value)
          }
          this.query()
        },(doError)=>{
          console.log(doError)
        })
      },
      changeChoseapplySubsidyTime (value) {
        console.log(value)
        // this.pinmu = undefined
        // if (value === '') {
        //   this.listThreeCategory = []
        // } else {
        //   this.getlistThreeCategory(value)
        // }
      },
      // 品目
      getlistThreeCategory(value){
        // var url=Http.test+'/common/listThreeCategory'
        var url=Http.test+'/sysDict/getItemsByType'
        var parmse={
          areaCode:this.result.areaCode,
          level:this.result.areaLevel,
        //   year: value
        }
        this.listThreeCategory = []
        Api.doPost(url,parmse,false,(res)=>{
          res.result.forEach(item => {
            if (item) {
              this.listThreeCategory.push(item)
            }
          })
        },(doError)=>{
          console.log(doError)
        })
      },
			// 查看
			handleClick(row) {
        var data = {
          pinmu: this.pinmu,
          factoryImei: this.factoryImei,
          companyName: this.companyName,
          imei: this.imei,
          currentPage: this.currentPage,
          checkcurrentPage: this.checkcurrentPage,
          choseYear: this.choseYear,
          choseqrcode: this.choseqrcode,
          choseimei: this.choseimei,
          choseapplySubsidyTime: this.choseapplySubsidyTime
        }
        this.$store.commit('discountData', data);
				this.$router.push({
					name: 'DiscountDetails',
					query: {
						imei: row.imei,
						id: row.id,
            qrNumber: row.qrNumber
					}
				})
			},
			// 获取列表数据
			query() {
				var onsearch = {
					provCode: this.provCityId.provCode,
					cityCode: this.provCityId.cityCode,
					countyCode: this.provCityId.countyCode,
					pinmu: this.pinmu,
					// year:this.year.toString(),
					njFactoryCode: this.factoryImei,
					factoryName: this.companyName,
					imei: this.imei,
					currentPage: this.currentPage,
					pageSize: this.checkcurrentPage,
					// year: this.choseYear,
					// hasQrCode: this.choseqrcode,
					// hasImei: this.choseimei,
					applySubsidyTime: this.choseapplySubsidyTime
				}
				this.loading = true
				this.isloading = true
				var url=Http.test+'/subsidyMachine/subsidyMachineList'
				Api.doPost(url, onsearch, false, (res) => {
					this.loading = false
					this.isloading = false
					this.tableData = res.result.dataSource
					this.total = res.result.totalRow
					if(this.tableData.length == 0) {
						this.nodata = true
					} else {
						this.nodata = false
					}
				}, (doError) => {
					console.log(doError)
				})
			},
			onSubmit() {
				this.nodata = false
				this.isloading = true
				this.currentPage = 1
				this.query()
			},
			handleSizeChange(val) {
				this.checkcurrentPage = val
				this.currentPage = 1
				this.query()
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage
        this.addIndex = (this.currentPage - 1) * this.checkcurrentPage + 1;
				this.query()
			}
		}
	}
</script>

<style scoped>
	.zanwu {
		text-align: center;
		font-size: 34px;
		color: #999;
		width: 100%;
		height: 600px;
		line-height: 600px;
	}
	
	.el-table {
		width: 98% !important;
		margin: auto;
		color: #fff;
	}
	
	.block {
		width: 100%;
		margin-top: 1vh;
		display: -webkit-box;
		-webkit-box-align: center;
		-webkit-box-pack: center;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.select-block {
		display: inline-block;
		padding: 0 20px;
		/*height: 40px;*/
		line-height: 40px;
		margin-top: 10px;
		width: 97%;
	}
	
	header {
		height: 0px !important;
	}
	
	form {
		display: inline-block
	}
	
	.parameter {
		/*width: 100%;*/
		height: 85px;
		line-height: 85px;
		background: #101c4a;
		margin-bottom: 10px;
	}
	
	.parameter>div {
		margin-left: 30px;
		margin-top: 30px;
		color: #75c3ff;
	}
	
	.parameter>div div {
		display: inline-block;
	}
	
	.parameter div span {
		display: inline-block;
		line-height: 40px;
	}
	
	.parameter>div div span:nth-child(2) {
		font-size: x-large;
		font-weight: bold;
		color: #fff;
		position: relative;
		top: 5px
	}
	
	.demonstration {
		padding-right: 20px;
	}
	
	.el-input__inner {
		border: 1px solid #273488 !important;
	}
	/* /deep/.pop-tit{width:260px !important;} */
</style>


// WEBPACK FOOTER //
// src/components/TableList/Discount.vue